import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Loader } from "@itandi/itandi-bb-ui/Loader";
import Link from "next/link";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { DealEditor } from "~/components/specifics/deals/[id]/related_deals/new/DealEditor";
import { useDeals } from "~/hooks/useDeals";
import { PATH as DealsPath } from "~/pages/deals";
import { PATH as DealPath } from "~/pages/deals/[id]/index";
import Styles from "./Page.module.scss";

type Props = {
	dealId: number | null;
};

export function Page({ dealId }: Props) {
	const { data: deal } = useDeals().show(dealId);
	if (!deal) return <Loader />;

	return (
		<DefaultV2>
			<div className={Styles.PageTop}>
				<Breadcrumbs
					items={[
						{ as: Link, href: DealsPath, label: "案件一覧" },
						{ as: Link, href: DealPath(deal.id), label: "案件詳細" },
						{ label: "関連する案件追加" }
					]}
				/>
				<h1 className={Styles.Title}>関連する案件追加</h1>
			</div>
			<DealEditor deal={deal} />
		</DefaultV2>
	);
}
